var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_510_3048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96713 5.21533C6.65777 5.21533 5.59253 6.28057 5.59253 7.58993C5.59253 8.89929 6.65777 9.96453 7.96713 9.96453C9.27649 9.96453 10.3417 8.89929 10.3417 7.58993C10.3417 6.28057 9.27649 5.21533 7.96713 5.21533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96712 0C3.5656 0 0 3.5656 0 7.96712C0 11.7177 5.79225 18.5086 7.50107 20.4319C7.75259 20.713 8.18904 20.713 8.44056 20.4319C10.1494 18.516 15.9416 11.7251 15.9416 7.96712C15.9416 3.5656 12.3686 0 7.96712 0ZM7.96712 11.5253C5.79225 11.5253 4.02424 9.75731 4.02424 7.58245C4.02424 5.40758 5.79225 3.63957 7.96712 3.63957C10.142 3.63957 11.91 5.40758 11.91 7.58245C11.91 9.75731 10.142 11.5253 7.96712 11.5253Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_510_3048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9416,
    height: 20.639,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerWhite);
export default __webpack_public_path__ + "static/media/map-marker-white.17e096ea48c7417286b559f3bda3d553.svg";
export { ForwardRef as ReactComponent };